

let positions = [[0,5],[12,10],[8,5],[12,0]];
let center = [6,5]
function rotate(position,deg,center){
    deg = deg/180*Math.PI;
    let centerx=center[0];
    let centery = center[1];
    let x0 = position[0]-centerx;
    let y0 = position[1]-centery;
    let x1 = (x0)*Math.cos(deg)-(y0)*Math.sin(deg) ;
    let y1 = (x0)*Math.sin(deg) + (y0)*Math.cos(deg);


    return [Math.floor(x1 * 100) / 100,Math.floor(y1 * 100) / 100]
}

function generateD(positions){
    let d="";
    positions.forEach((v,i)=>{
        if( i ==0){
            d+=`M`;
        }else{
            d+=`L`
        }
        d+=`${v[0]}  ${v[1]}`
    })
    d+="Z"
    return d;
}


export const arrowRightD = generateD(positions.map(v=>rotate(v,180,center)))
export const arrowLeftD= generateD(positions.map(v=>rotate(v,0,center)))

export const arrowUpD= generateD(positions.map(v=>rotate(v,90,center)))
export const arrowDownD= generateD(positions.map(v=>rotate(v,-90,center)))


// WEBPACK FOOTER //
// ./src/assets/tflow/render/connection/arrowD.js